/*
 * Multi Step Form
 *
 * Used when the form needs to be split to multiple steps.
 * Form tag still would wrap whole steps.
 **/
require('custom/gtm-datalayer');

custom.multiStepForm = (() => {
  const formClassName = 'js-multi-form';
  const submitClassName = 'js-multi-form-submit';
  const pageCountClassName = 'js-multi-form-page-count';
  const toggleableBackButton = 'js-fixed-nav-back';
  const sectionClassName = `${formClassName}-section`;
  const navClassName = `${formClassName}-nav`;
  const currentClass = 'current';
  const parentClassName = 'field__input-wrapper';
  const emailID = 'BAD_email';
  const togglePlaceholderForDesktop = 'js-has-desktop-placeholder';

  const emailErrorContainerClass = 'error-email';
  const existedEmailErrorClass = 'js-existed-email-error';
  const userNameTaken =
    'This username is already taken. Email <a class="text-red" href="mailto:customerservice@loloirugs.com?subject=I%20need%20assistance%20creating%20a%20Loloi%20account">customerservice@loloirugs.com</a> for assistance.';
  const formAlreadySubmitted =
    'You have already applied for a Loloi account. Email <a class="text-red" href="mailto:customerservice@loloirugs.com?subject=I%20am%20following%20up%20to%20open%20a%20Loloi%20trade%20account">customerservice@loloirugs.com</a> for assistance.';

  let emailCheckStep = 1;

  let autocomplete;
  //to track how far customer has gotten
  let completedStep = 0;

  var componentForm = {
    street_number: 'short_name',
    premise: 'long_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'long_name',
    country: 'long_name',
    postal_code: 'short_name',
  };

  // Parsley option variable
  const parsleyOption = {
    classHandler: function (el) {
      return el.$element.closest(`.${parentClassName}`);
    },
  };

  // Form sections
  const $sections = $(`.${sectionClassName}`);

  /**
   * geolocate
   * @function
   *
   * Attempts to set gelocation for autocomplete to bias results based on the user's current location.
   */
  function geolocate() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const geolocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        const circle = new google.maps.Circle({
          center: geolocation,
          radius: position.coords.accuracy,
        });
        autocomplete.setBounds(circle.getBounds());
      });
    }
  }

  /**
   * initAutocomplete
   * @function
   *
   * Initializes Google Places Autocomplete. Restricts search to geographical location types.
   * When the user selects an address from the drop-down, populate the address fields in the form.
   */
  function initAutocomplete() {
    var autocompleteInput = document.getElementById('BAD_business-address');
    var observerHack = new MutationObserver(function () {
      observerHack.disconnect();
      $('#BAD_business-address').attr('autocomplete', 'new-password');
    });

    observerHack.observe(autocompleteInput, {
      attributes: true,
      attributeFilter: ['autocomplete'],
    });
    autocomplete = new google.maps.places.Autocomplete(autocompleteInput, {
      types: ['geocode'],
    });

    // Restricts the set of place fields that are returned to just the address components.
    autocomplete.setFields(['address_component']);
    autocomplete.addListener('place_changed', fillInAddress);
  }

  /**
   * fillInAddress
   * @function
   *
   * Changes country, then fills in all other valid fields.
   */
  function fillInAddress() {
    // Get the place details from the autocomplete object.
    const place = autocomplete.getPlace();
    for (var component in componentForm) {
      $(`[data-google-id="${component}"]`).val('');
      $(`[data-google-id="${component}"]`).prop('disabled', false);
    }
    // Need to set country first and then trigger zip and province changes...
    for (var i = 0; i < place.address_components.length; i++) {
      const addressType = place.address_components[i].types[0];
      if (addressType === 'country') {
        const val = place.address_components[i]['long_name'];
        $('#AddressCountry_BAD').val(val);
        if (!$('#AddressCountry_BAD').val()) {
          const valShort = place.address_components[i]['short_name'];
          $('#AddressCountry_BAD').val(valShort);
        }
        document
          .getElementById('AddressCountry_BAD')
          .dispatchEvent(new Event('change'));
      }
    }
    // Set all other fields
    for (var i = 0; i < place.address_components.length; i++) {
      let addressType = place.address_components[i].types[0];
      if (addressType === 'country') continue;
      if (addressType === 'postal_town') {
        addressType = 'locality';
      }
      if (componentForm[addressType]) {
        const val = place.address_components[i][componentForm[addressType]];
        if (addressType === 'route') {
          const streetAddress = $('#BAD_business-address').val() + ' ' + val;
          $('#BAD_business-address').val(streetAddress);
        } else if (addressType === 'premise') {
          const streetAddress = val + ' ' + $('#BAD_business-address').val();
          $('#BAD_business-address').val(streetAddress);
        } else {
          $(`[data-google-id="${addressType}"]`).val(val);
        }
      }
    }
  }

  /**
   * Get Url Query Object
   * @function
   *
   * return an object contains key and value in url
   */
  function getUrlQueryObject() {
    const queryArr = window.location.search.substring(1).split('&');
    let queryObj = {};

    queryArr.forEach((str) => {
      const key = str.substring(0, str.indexOf('='));
      const newObj = {};
      newObj[key] = str.substring(str.indexOf('=') + 1);
      queryObj = Object.assign({}, queryObj, newObj);
    });

    return queryObj;
  }

  /**
   * Navigate To Steps
   * @method
   *
   * @param {number} index - Section index number
   */
  function navigateTo(index) {
    //update current section
    $sections.removeClass(currentClass);
    $sections.eq(index).addClass(currentClass);
    //show/hide continue buttons depending on step
    const atLast = index >= $sections.length - 1;
    $(`.${navClassName} .btn.next`).toggle(!atLast);
    $(`.${navClassName} [type="submit"]`).toggle(atLast);
    //update current nav tab
    currentClassSwitcher(index);
    //update any page count indicators
    $(`.${pageCountClassName}`).text(`${index + 1}`);
    //Hide back button on first step
    if(index == 0) {
      $(`.${toggleableBackButton}`).hide();
    } else {
      $(`.${toggleableBackButton}`).show();
    }
    //reset scroll
    window.scrollTo(0, 0);
    //if mobile scroll current tab into view
    if ($(window).width() < 768) {
      document.getElementById('tab-step-' + (index + 1)).scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start',
      });
    }
  }

  /**
   * Update input placeholders that have different content for mobile and desktop
   * @method
   */
  const updatePlaceholders = () => {
    if ($(window).width() < 768) {
      // Update input placeholder for mobile.
      $(`.${togglePlaceholderForDesktop} input, .${togglePlaceholderForDesktop} textarea`).each(function() {
        const placeholder = $(this).data('mobileplaceholder');
        if(!placeholder) return;
        $(this).attr('placeholder', placeholder);
      });
    } else {
      // Update input placeholder for desktop.
      $(`.${togglePlaceholderForDesktop} input, .${togglePlaceholderForDesktop} textarea`).each(function() {
        const placeholder = $(this).data('desktopplaceholder');
        if(!placeholder) return;
        $(this).attr('placeholder', placeholder);
      });
    }
  }

  /**
   * Current Block Index
   * @function
   *
   * returns current active block's index number
   */
  function currentBlockIndex() {
    return $sections.index($sections.filter(`.${currentClass}`));
  }

  /**
   * Add Parsley Group Attribute
   * @function
   *
   * @param {number} index - Section index number
   * @param {object} section - Form section DOM object
   */
  function addParsleyGroupAttribute(index = 0, section = null) {
    return $(section)
      .find(':input:not(.prev)')
      .attr('data-parsley-group', `step-${index}`);
  }

  /**
   * A function that switches the current class based on the index.
   *
   * @param {number} index - The index of the element to switch the current class to.
   * @return {jQuery} The jQuery object with the current class switched.
   */
  function currentClassSwitcher(index = 0) {
    $(`.${navClassName} [data-multi-form-step]`).removeClass(currentClass);
    return $(`.${navClassName} [data-multi-form-step="${index + 1}"]`).addClass(
      currentClass,
    );
  }

  /**
   * backHandler
   * @function
   *
   * @param {object} event object - Button or navigation link click event
   * Back to Previous Step
   */
  function backHandler(event = null, index = currentBlockIndex() - 1) {
    if(index < 0) {
      index = 0;
    }
    event.preventDefault();
    stepQueryHandler(index, true);
    return navigateTo(index);
  }

  /**
   * forwardToIndex
   * @function
   *
   * @param {number} index - Index No of step to go
   */
  function forwardToIndex(index = null) {
    // Data for clicking into step 2
    const data = {
      eventCategory: 'Become A Dealer',
      eventAction: 'CTA Click',
      eventLabel: 'Continue',
    };
    custom.gtmDatalayer.gtmPush(data);
    //track furthest step
    completedStep = index > completedStep ? index : completedStep;
    existedCustomerErrorHandler(false);
    stepQueryHandler(index);
    navigateTo(index);
  }

  /**
   * existedCustomerErrorHandler
   * @function
   *
   * @param {boolean} isError specifies whether error happens or gone
   * if happens injects a message, otherwise delete
   * NOTE: this function is heavily "Contents Related", should consider to move to become-a-dealer.js
   */
  function existedCustomerErrorHandler(
    isError = true,
    errorDisclaimer = userNameTaken,
  ) {
    let $emailInputContainer;

    $emailInputContainer = $(`#${emailID}`).closest(`.${parentClassName}`);

    if (isError) {
      if (!$emailInputContainer.find(`.${existedEmailErrorClass}`)) return;
      $emailInputContainer.addClass('parsley-error');
      $emailInputContainer
        .find(`.${emailErrorContainerClass}`)
        .prepend(`<p class="${existedEmailErrorClass}">${errorDisclaimer}</p>`);
      //send focus to email input
      $(`#${emailID}`).trigger('focus');
    } else {
      $emailInputContainer.removeClass('parsley-error');
      $emailInputContainer.find(`.${existedEmailErrorClass}`).remove();
    }
  }

  /**
   * forwardHandler
   * @function
   *
   * @param {object} event object - Button or navigation link click event
   * Forward to Next Step, with validations to fields on current step.
   */
  function forwardHandler(event = null, index = currentBlockIndex() + 1) {
    event.preventDefault();
    //validate the current step we're leaving
    const currentIndex = currentBlockIndex() + 1;
    $(`.${formClassName}`)
      .parsley(parsleyOption)
      .whenValidate({
        group: 'step-' + currentIndex,
      })
      .done(() => {
        if (!window.MUAPP.customerExists) return forwardToIndex(index);

        if (index == emailCheckStep) {
          // Check with SPARS record ========================================
          // NOTE: this is "Contents Driven" validator, might think about how to move this to become-a-dealer.js
          const emailInputValue = $(`#${emailID}`).val();
          const postForm = $(`.${formClassName}`).data('form-id');
          window.MUAPP.queryBasinForm(emailInputValue, postForm).then(
            (data) => {
              if (data.submissions && data.submissions.length > 0) {
                window.MUAPP.customerExists(emailInputValue).then((res) => {
                  return !res.shopify_customer
                    ? existedCustomerErrorHandler(true, formAlreadySubmitted)
                    : existedCustomerErrorHandler();
                });
              } else {
                window.MUAPP.customerExists(emailInputValue).then((res) => {
                  return !res.shopify_customer
                    ? forwardToIndex(index)
                    : existedCustomerErrorHandler();
                });
              }
            },
            (err) => {
              console.log('error with usebasin', err);
              return existedCustomerErrorHandler();
            },
          );
        } else {
          forwardToIndex(index);
        }
      });
  }

  /**
   * stepNavigationHandler
   * @function
   *
   * @param {object} event - Button or navigation link click event
   * @description Navigate to corresponding step depending on the step they currently are
   */
  function stepNavigationHandler(event = null) {
    // Get the target step index from the clicked element
    const targetIndex = $(event.currentTarget).data('multi-form-step') - 1;

    // Get the current step index from the active tab
    const currentIndex =
      $(`.${navClassName} .${currentClass}`).data('multi-form-step') - 1;

    // If the target index or current index is not a number, prevent default action
    if (isNaN(targetIndex) || isNaN(currentIndex)) {
      return event.preventDefault();
    }

    // If clicking the current tab, prevent default action
    if (targetIndex == currentIndex) {
      return event.preventDefault();
    }

    // If trying to go too far forward from current step, prevent default action
    if (targetIndex > completedStep && currentIndex < completedStep) {
      return event.preventDefault();
    }

    // Call forwardHandler if target index is greater than current index, otherwise call backHandler
    return targetIndex > currentIndex
      ? forwardHandler(event, targetIndex)
      : backHandler(event, targetIndex);
  }

  /**
   * Handles the submit callback event.
   *
   * @param {null|Event} event - The event object. (optional)
   * @return {undefined}
   */
  function submitCallbackHandler(event = null) {
    event.preventDefault();
    $(`.${formClassName}`).parsley(parsleyOption).validate();
    if ($(`.${formClassName}`).parsley(parsleyOption).isValid())
      window.pubsub.trigger('hasMultiFromValidated');
  }

  /**
   * Handles the step query parameter in the URL.
   * If the step query parameter is not present, it adds it with a default value.
   * It updates the URL with the modified query parameters.
   * @param {number} stepNo - The step number to be added to the query parameter.
   */
  function stepQueryHandler(stepNo = null) {
    // Initialize autocomplete if it hasn't been done already
    if (!autocomplete) initAutocomplete();

    // Get the current query parameters from the URL
    const query = getUrlQueryObject();

    // Build the search string with the modified query parameters
    let searchStr = '';
    Object.keys(query).forEach((key, index) => {
      const prefix = index == 0 ? '?' : '&';
      if (key == 'step') query.step = `0${stepNo + 1}`.slice(-2);
      searchStr += `${prefix}${key}=${query[key]}`;
    });

    // If the step query parameter is not present, add it with a default value
    if (!query.step)
      return window.history.pushState(
        { step: 1 },
        document.title,
        window.location.pathname + searchStr + '&step=01',
      );

    // update the URL with the modified query parameters
    return window.history.pushState(
      { step: stepNo + 1 },
      document.title,
      window.location.pathname + searchStr,
    );
  }

  /**
   * Initializes the form and sets up event handlers.
   */
  function init() {
    // Check if the form element exists and call stepQueryHandler
    if ($(`.${formClassName}`).length) {
      stepQueryHandler();
      // on browser back/forward use the state object to navigate to that step
      // Attach an event listener for the 'popstate' event
      window.addEventListener('popstate', (event) => {
        // Check if the event has a 'state' property and a 'step' property
        if (event.state && event.state.step) {
          // Get the target index from the 'step' property of the event state
          const targetIndex = event.state.step - 1;

          // Get the current index from the 'multi-form-step' data attribute of the current element
          const currentIndex =
            $(`.${navClassName} .${currentClass}`).data('multi-form-step') - 1;

          // Check if the target index is equal to the current index
          if (targetIndex == currentIndex) return;

          // Call the 'navigateTo' function with the target index
          return navigateTo(targetIndex);
        }
      });
    } else {
      return;
    }

    // Loop through each section and add Parsley group attribute
    $.each($sections, (index, section) => {
      addParsleyGroupAttribute(index + 1, section);
    });

    // Navigate to the first step
    navigateTo(0);

    // Set up event handlers for previous and next buttons
    $(`.${navClassName} .prev`).on('click', backHandler);
    $(`.${navClassName} .next`).on('click', forwardHandler);

    // Set up event handler for step navigation buttons
    $(`.${navClassName} [data-multi-form-step]`).on(
      'click',
      stepNavigationHandler,
    );

    // Set up event handler for submit button
    $(`.${submitClassName}`).on('click', submitCallbackHandler);
    updatePlaceholders();
    $(window).on('resize', updatePlaceholders);
  }

  return {
    init,
    geolocate,
    initAutocomplete,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/multi-step-form.js